import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as generalActions from '../../../../actions/generalAction';
import PriceMakeupFlight from './PriceMakeupFlight';

const mapStateToProps = state => {
    return {
        generalState: state.generalReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFlightConfig: () => dispatch(generalActions.getFlightConfig()),
        setFlightConfig: (FlightConfig) => dispatch(generalActions.setFlightConfig(FlightConfig)),
        updateFlightConfig: (flightConfig) => dispatch(generalActions.updateFlightConfig(flightConfig)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PriceMakeupFlight));
